/* Замер показателей живыми покупателями — свой, потому что поле CrUX молчит про товарные.
 *
 * ДВА НЕЗАВИСИМЫХ БЛОКА, ДВА РАЗНЫХ beacon:
 *   1) INP  — уходит только с просмотров, где было взаимодействие (как раньше, 10.09.2026);
 *   2) CWV  — CLS, LCP, FCP, TTFB и «блокировка потока» (18.09.2026), уходит с КАЖДОГО
 *      просмотра, потому что у CLS и LCP взаимодействие не нужно.
 * Протокол INP не менялся: приёмник и inp_report.py продолжают работать как раньше.
 *
 * ────────────────────────── БЛОК 1: INP ──────────────────────────
 *
 * ЗАЧЕМ. 09.09.2026 разбор показал расхождение: лаборатория даёт TBT 4.2 с и
 * TTI 22.9 с на мобильной товарной, а поле — INP p75 = 170 мс, то есть «хорошо».
 * Спор решить было нечем: CrUX не отдаёт данных на уровне URL для наших
 * товарных и подставляет origin, разбавленный главной и коллекциями. Именно
 * самый тяжёлый шаблон оказался единственным, про который поле не говорит.
 * Этот скрипт закрывает дырку: меряет задержку реальных взаимодействий и
 * присылает её с пометкой типа страницы, чтобы товарную можно было сравнить
 * с остальным сайтом на одних и тех же посетителях.
 *
 * ЧТО ИМЕННО МЕРИМ. Худшую задержку взаимодействия за просмотр. Для страниц
 * меньше чем с 50 взаимодействиями это ровно INP по спецификации (она отбрасывает
 * по одному худшему на каждые 50, а до 50 отбрасывать нечего). На страницах с
 * очень активным кликером наша цифра будет чуть пессимистичнее настоящего INP —
 * в сторону «хуже, чем есть», и это осознанный выбор: недооценить лаг опаснее.
 *
 * ПОЧЕМУ ПОРОГ 16, А НЕ 40. У web-vitals по умолчанию durationThreshold 40, и с
 * ним быстрые взаимодействия не создают записей вообще. Тогда отправка случалась
 * бы только на просмотрах, где лаг уже был, и p75 считался бы по одним плохим
 * просмотрам — систематический перекос в худшую сторону. 16 — минимум, который
 * разрешает спецификация; ниже браузер всё равно клампит.
 *
 * ОТДЕЛЬНО ПРО «ВЗАИМОДЕЙСТВИЕ БЫЛО, НО БЫСТРОЕ». Даже с порогом 16 мгновенный
 * тап записи не создаст. Поэтому факт взаимодействия ловим независимо, дешёвыми
 * слушателями, и тогда отправляем inp=0. Без этого просмотры с идеальным
 * откликом вообще не попадали бы в статистику — тот же перекос.
 *
 * ────────────────────────── БЛОК 2: CWV ──────────────────────────
 *
 * ЗАЧЕМ. 18.09.2026: на /collections/sunglasses GTmetrix показал CLS 0.12, а в
 * psi_crux мобильная главная даёт 0.73 и крупная коллекция 1.56, при том что поле
 * CrUX на уровне origin — 0.05 («хорошо»). Origin разбавлен товарными, где трафика
 * больше. Спор «лабораторная гонка или реальная боль» без своих данных не решить.
 *
 * ЧТО МЕРИМ (всё пассивными PerformanceObserver с buffered:true, без чтения
 * раскладки и без сети до ухода со страницы):
 *   cls  — максимальное «окно сдвигов» по определению web-vitals: сдвиги с паузой
 *          меньше 1 с между собой и не длиннее 5 с, берётся худшее окно; сдвиги сразу
 *          после ввода пользователя (hadRecentInput) не считаются. Уходит в
 *          тысячных (121 = 0.121), чтобы приёмник принимал только целые.
 *   lcp  — время последнего кандидата LCP, мс.
 *   fcp, ttfb — мс от начала навигации.
 *   tbt  — «блокировка потока»: сумма (длительность − 50 мс) длинных задач между FCP и
 *          10-й секундой. Это ПОЛЕВОЙ ПРИБЛИЗИТЕЛЬ, не Lighthouse TBT: у Lighthouse
 *          окно кончается на TTI, а TTI в поле неизвестен. Использовать для
 *          сравнения шаблонов и трендов, а не как число, сопоставимое с лабораторией.
 *   dm, et — объём памяти устройства (ГБ, грубо) и тип соединения. Нужны, чтобы
 *          отличить «медленный код» от «слабый телефон» — ровно тот спор, из-за
 *          которого затевался замер. Ни то ни другое не идентифицирует человека.
 *   fa   — активен ли fish на момент ухода (1/0), осмысленно на коллекциях и поиске.
 *   cs, cv — ВИНОВНИК САМОГО КРУПНОГО СДВИГА (только если CLS просмотра >= 0.05): краткий
 *          селектор элемента («родитель>элемент», до 64 символов, только [A-Za-z0-9_#.>-],
 *          берётся хвост, где сам элемент) и вес этого одиночного сдвига в тысячных.
 *          Нужен, чтобы редкие выбросы CLS (0.7-1.0 на случайные дни, 18.09.2026) можно
 *          было разобрать по реальным посетителям, а не гадать по цифре. Это селекторы
 *          НАШЕЙ вёрстки, не содержимое страницы и не данные пользователя.
 *
 *   st, sy, vh, py, cy, pp — ГДЕ И КОГДА был этот сдвиг (02.10.2026, только вместе с cs):
 *          мс от навигации, прокрутка, высота окна, верх элемента до/после (может быть < 0)
 *          и handle товара на товарных. Нужны, чтобы разобрать «подвал уезжает при загрузке».
 *   ph, ch, pw, cw, kl — (10.10.2026, только вместе с cs) высота и ширина элемента до/после
 *          сдвига и битовая маска в момент сдвига: 1 = Klaviyo заблокировал прокрутку body,
 *          2 = открыт модальный диалог. Нужны для «фото Wiley X уезжает на 22 px».
 *
 * ЧЕГО НЕТ НАМЕРЕННО: идентификатора посетителя, URL, куки. Только тип страницы (и handle
 * товара в pp — это название товара, не данные человека) —
 * этого хватает для вопроса «какой шаблон тяжелее».
 *
 * СТОИМОСТЬ ДЛЯ ПОКУПАТЕЛЯ. Скрипт defer, в сеть при загрузке не ходит: единственный
 * запрос — sendBeacon при скрытии вкладки (≈150 байт), браузер отправляет его сам,
 * не задерживая ни закрытие, ни переход. Наблюдатели пассивны: работа в
 * колбэках — арифметика над записями, которые браузер и так создаёт.
 *
 * ПЕРЕКЛЮЧАТЕЛЬ ОБЪЁМА: CWV_SAMPLE ниже. 1 = все просмотры, 0.25 = каждый четвёртый.
 */
(function () {
  var ENDPOINT = 'https://api.heavyglare.com/vt-3e91c7';
  var CWV_SAMPLE = 1;

  if (!window.PerformanceObserver || !navigator.sendBeacon) return;

  /* РОБОТЫ НЕ МЕРЯЮТСЯ (29.09.2026). Googlebot рендерит товарные в окне 1024×1024
     и шлёт beacon как обычный посетитель: за неделю это ~82% «десктопных» замеров
     товарных (ровный поток по часам, IP 66.249.x / 192.178.4.x в логе bot-score),
     и p75 LCP 3.1 с / CLS 0.14 в отчёте были его цифрами, а не покупателей.
     Сюда же — наши лаборатории (Lighthouse, sitespeed, GTmetrix, WebPageTest).
     `bot\b`, а не просто `bot`: у телефонов Cubot в UA «CUBOT_…», это люди. */
  if (navigator.webdriver ||
      /bot\b|crawl|spider|slurp|headless|lighthouse|gtmetrix|ptst\/|inspectiontool|mediapartners|pingdom/i
        .test(navigator.userAgent || '')) return;

  var types = PerformanceObserver.supportedEntryTypes || [];

  /* currentScript живёт только пока скрипт выполняется синхронно — читаем сразу. */
  var script = document.currentScript;
  var pageType = (script && script.getAttribute('data-pt')) || '';

  /* ══════════ Блок 1: INP (логика не менялась, только обёрнута в функцию) ══════════ */
  function startInp() {
    var worst = 0;          /* худшая задержка взаимодействия, мс */
    var counted = 0;        /* взаимодействий с записью (>=16 мс) */
    var interacted = false; /* было ли взаимодействие вообще */
    var sent = false;

    function absorb(entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        /* interactionId == 0 у событий, не сгруппированных в взаимодействие
           (скролл, движение мыши) — они к INP не относятся. */
        if (!e.interactionId) continue;
        counted++;
        if (e.duration > worst) worst = e.duration;
      }
    }

    var po;
    try {
      po = new PerformanceObserver(function (list) { absorb(list.getEntries()); });
      po.observe({ type: 'event', buffered: true, durationThreshold: 16 });
    } catch (e) { return; }

    function mark() { interacted = true; }
    /* capture + passive: вешаемся выше любого обработчика страницы и ничего не
       задерживаем. Нас интересует только сам факт тапа, не его обработка. */
    var opts = { capture: true, passive: true };
    addEventListener('pointerdown', mark, opts);
    addEventListener('keydown', mark, opts);

    function send() {
      if (sent) return;
      /* Просмотр без взаимодействий INP не имеет — там нечего мерить, и молчание
         здесь правильнее нуля: ноль означал бы «отклик идеальный». */
      if (!interacted) return;
      sent = true;
      try { absorb(po.takeRecords()); } catch (e) {}
      var inp = Math.min(Math.round(worst), 60000);
      try {
        navigator.sendBeacon(ENDPOINT + '?inp=' + inp + '&n=' + counted +
                             '&pt=' + encodeURIComponent(pageType));
      } catch (e) {}
    }

    /* pagehide и скрытие вкладки — единственные события, которые браузер
       гарантирует перед уходом; unload на мобильных не срабатывает. */
    addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') send();
    });
    addEventListener('pagehide', send);
  }

  if (types.indexOf('event') >= 0) startInp();   /* Safari до 16.4 — INP не измерим */

  /* ══════════ Блок 2: CWV ══════════ */
  function startCwv() {
    /* Страница, открытая в фоне или предрендеренная, даёт искажённые LCP/CLS
       (браузер не красил кадры) — такие просмотры не берём вовсе. */
    if (document.visibilityState === 'hidden' || document.prerendering) return;
    if (CWV_SAMPLE < 1 && Math.random() >= CWV_SAMPLE) return;

    var has = function (t) { return types.indexOf(t) >= 0; };
    /* sawShiftApi берём из поддержки API, а НЕ из факта прихода записей: у страницы
       без единого сдвига колбэк не вызывается вовсе, и «поддержка есть, сдвигов
       нет» без этого отправлялась бы как «данных нет». Тогда в статистику попадали
       бы только страницы с CLS > 0 — тот же перекос в худшую сторону, что описан
       выше для INP. */
    var cls = 0, sessVal = 0, sessFirst = 0, sessLast = 0, sawShiftApi = has('layout-shift');
    var maxShift = 0, maxDesc = '';   /* самый крупный одиночный сдвиг и его виновник */
    /* 02.10.2026: где и когда был этот сдвиг. Подвал товарной «уезжает» у покупателей
       (0.08 × сотни просмотров), а в лаборатории воспроизводится через раз — нужен
       момент (мс от навигации), прокрутка, высота окна и верх элемента до/после. */
    var maxAt = null, maxSy = 0, maxPy = null, maxCy = null;
    /* 10.10.2026: размер виновника до/после и всплывашка Klaviyo. Фото Wiley X уезжает
       ровно на 22 px при неподвижном контейнере — по одному верху не отличить
       «сжалось на 44 px и отцентровалось» от «толкнули». */
    var maxPh = null, maxCh = null, maxPw = null, maxCw = null, maxKl = 0;
    var lcp = 0, fcp = 0;
    var tasks = [];          /* длинные задачи: [старт, длительность] */
    var sent = false;
    var obs = [];

    function observe(type, cb) {
      if (!has(type)) return;
      try {
        var o = new PerformanceObserver(function (l) { cb(l.getEntries()); });
        o.observe({ type: type, buffered: true });
        obs.push({ o: o, cb: cb });
      } catch (e) {}
    }

    function nodeDesc(n) {
      if (!n || !n.tagName) return '';
      var d = String(n.tagName).toLowerCase();
      if (n.id) return d + '#' + n.id;
      if (typeof n.className === 'string' && n.className.trim()) {
        d += '.' + n.className.trim().split(/\s+/).slice(0, 2).join('.');
      }
      return d;
    }
    /* Источник сдвига с наибольшей площадью; узел уже мог уйти из DOM (тогда null). */
    function shiftDesc(e) {
      var best = null, bestSrc = null, area = -1, srcs = e.sources || [];
      for (var i = 0; i < srcs.length; i++) {
        var s = srcs[i];
        if (!s || !s.node) continue;
        var r = s.currentRect || {};
        var a = (r.width || 0) * (r.height || 0);
        if (a > area) { area = a; best = s.node; bestSrc = s; }
      }
      if (!best) return '';
      maxPy = bestSrc.previousRect ? Math.round(bestSrc.previousRect.y) : null;
      maxCy = bestSrc.currentRect ? Math.round(bestSrc.currentRect.y) : null;
      if (bestSrc.previousRect) { maxPh = Math.round(bestSrc.previousRect.height); maxPw = Math.round(bestSrc.previousRect.width); }
      if (bestSrc.currentRect) { maxCh = Math.round(bestSrc.currentRect.height); maxCw = Math.round(bestSrc.currentRect.width); }
      var d = nodeDesc(best), p = best.parentElement ? nodeDesc(best.parentElement) : '';
      return p ? p + '>' + d : d;
    }

    observe('layout-shift', function (es) {
      for (var i = 0; i < es.length; i++) {
        var e = es[i];
        if (e.hadRecentInput) continue;   /* сдвиг после клика/ввода не считается */
        if (e.value > maxShift) {         /* виновника описываем сразу: позже узел может исчезнуть */
          maxShift = e.value;
          maxAt = e.startTime;
          maxSy = window.scrollY || 0;   /* колбэк приходит почти сразу — прокрутка та же */
          maxPy = maxCy = maxPh = maxCh = maxPw = maxCw = null;
          try { maxDesc = shiftDesc(e); } catch (err) { maxDesc = ''; }
          try {
            maxKl = (document.body && document.body.classList.contains('klaviyo-prevent-body-scrolling') ? 1 : 0) |
                    (document.querySelector('[role="dialog"][aria-modal="true"]') ? 2 : 0);
          } catch (err) { maxKl = 0; }
        }
        if (sessVal && e.startTime - sessLast < 1000 && e.startTime - sessFirst < 5000) {
          sessVal += e.value;
          sessLast = e.startTime;
        } else {
          sessVal = e.value;
          sessFirst = sessLast = e.startTime;
        }
        if (sessVal > cls) cls = sessVal;
      }
    });
    observe('largest-contentful-paint', function (es) {
      if (es.length) lcp = es[es.length - 1].startTime;
    });
    observe('paint', function (es) {
      for (var i = 0; i < es.length; i++) {
        if (es[i].name === 'first-contentful-paint') fcp = es[i].startTime;
      }
    });
    observe('longtask', function (es) {
      for (var i = 0; i < es.length && tasks.length < 300; i++) {
        tasks.push([es[i].startTime, es[i].duration]);
      }
    });

    function sendCwv() {
      if (sent) return;
      sent = true;
      /* Записи, которые браузер ещё не успел доставить наблюдателю, забираем
         вручную — иначе последний сдвиг/кандидат LCP перед уходом потерялся бы. */
      for (var i = 0; i < obs.length; i++) {
        try {
          var rest = obs[i].o.takeRecords();
          if (rest.length) obs[i].cb(rest);
        } catch (e) {}
      }
      var q = [];
      var add = function (k, v) { if (v !== null && v !== undefined && v === v) q.push(k + '=' + encodeURIComponent(v)); };

      if (sawShiftApi) add('cls', Math.min(Math.round(cls * 1000), 10000));
      if (cls >= 0.05 && maxDesc) {
        /* Хвост, а не голова: у длинных id (shopify-section-template--...) значимо окончание. */
        var cs = maxDesc.replace(/[^A-Za-z0-9_#.>\-]/g, '').slice(-64);
        if (cs) {
          add('cs', cs); add('cv', Math.min(Math.round(maxShift * 1000), 10000));
          if (maxAt !== null) add('st', Math.min(Math.round(maxAt), 60000));
          add('sy', Math.min(Math.max(Math.round(maxSy), 0), 100000));
          add('vh', Math.min(window.innerHeight || 0, 10000));
          if (maxPy !== null) add('py', Math.max(Math.min(maxPy, 100000), -100000));
          if (maxCy !== null) add('cy', Math.max(Math.min(maxCy, 100000), -100000));
          var clampSz = function (v) { return Math.min(Math.max(v, 0), 100000); };
          if (maxPh !== null) { add('ph', clampSz(maxPh)); add('pw', clampSz(maxPw)); }
          if (maxCh !== null) { add('ch', clampSz(maxCh)); add('cw', clampSz(maxCw)); }
          add('kl', maxKl);
          /* Handle товара — только на товарных и только вместе с виновником сдвига:
             нужен, чтобы понять, на каких товарах уезжает подвал. Не URL целиком. */
          var hm = pageType === 'product' && location.pathname.match(/\/products\/([a-z0-9\-]{1,80})/);
          if (hm) add('pp', hm[1]);
        }
      }
      if (lcp) add('lcp', Math.min(Math.round(lcp), 60000));
      if (fcp) add('fcp', Math.min(Math.round(fcp), 60000));
      try {
        var nav = performance.getEntriesByType('navigation')[0];
        if (nav && nav.responseStart > 0) add('ttfb', Math.min(Math.round(nav.responseStart), 60000));
      } catch (e) {}
      if (fcp && has('longtask')) {
        var block = 0;
        for (var j = 0; j < tasks.length; j++) {
          if (tasks[j][0] >= fcp && tasks[j][0] <= 10000 && tasks[j][1] > 50) block += tasks[j][1] - 50;
        }
        add('tbt', Math.min(Math.round(block), 60000));
      }
      if (navigator.deviceMemory) add('dm', Math.min(Math.round(navigator.deviceMemory), 64));
      var et = navigator.connection && navigator.connection.effectiveType;
      if (et) add('et', et);
      add('fa', document.body && document.body.classList.contains('fish-active') ? 1 : 0);
      if (!q.length) return;

      try {
        navigator.sendBeacon(ENDPOINT + '?k=cwv&' + q.join('&') + '&pt=' + encodeURIComponent(pageType));
      } catch (e) {}
    }

    addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') sendCwv();
    });
    addEventListener('pagehide', sendCwv);
  }

  startCwv();
})();
